
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ie/download-app",
      function () {
        return require("private-next-pages/ie/download-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ie/download-app"])
      });
    }
  